import styled from 'styled-components'
import { Button, Checkbox, Col, DatePicker, Form, Input, Menu, Modal, Row, Select } from 'antd'
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons'

import { theme } from '../../styles'

const ContentContainer = styled(Col)`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: visible;
  height: 100%;
  .option-button {
    font-size: 1.5rem;
    align-items: center;
    display: flex;
  }
  .filters-container {
    flex: 1;
    transition: all ease 200ms;
    .ant-select {
      min-width: 8rem;
    }
    .filters-list {
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem;
      height: 100%;
      overflow-y: auto;
    }
  }
  #displayFiltersButton {
    cursor: pointer;
    position: absolute;
    bottom: 1.5rem;
    left: 0;
    transform: translateX(-100%);
    display: none;
    padding: 0.5rem;
    border-radius: 0.25rem 0 0 0.25rem;
    background-color: ${props => props.theme.primaryColor};
    box-shadow: 0 0 0.25rem ${props => props.theme.lightGray};
    .anticon svg {
      color: ${props => props.theme.white};
    }
  }
  &.admin-dashboard {
    height: 100%;
  }
  &.availability-declaration {
    padding: 1rem;
    gap: 1rem;
  }
  .blocktrain-detail__data {
    .ant-form-item {
      flex: 1;
      max-width: 14rem;
      .ant-form-item-row {
        width: 100%;
        flex-wrap: nowrap;
      }
    }
    .ant-form-item-label {
      max-height: fit-content;
    }
  }
  @media (max-width: 768px) {
    &.admin-dashboard {
      height: 100%;
    }
  }
  @media (max-width: ${props => props.theme.size.md}) {
    .filters-container {
      transform: translateX(100%);
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: 10;
      background-color: ${props => props.theme.white};
      max-width: 80%;
      top: 0;
      display: flex;
      border-left: 1px solid #f0f0f0;
      width: 14rem;
      box-shadow: 0 0 0 ${props => props.theme.darkGray};
      #displayFiltersButton {
        display: flex;
      }
      .ant-select {
        flex: unset;
        min-width: 100%;
      }
      .filters-list {
        padding: 0.5rem;
        width: 100%;
        align-items: flex-end;
        flex-wrap: unset;
        flex-direction: column;
      }
      &.filters-displayed {
        transform: unset;
        box-shadow: 0 0 1rem ${props => props.theme.darkGray};
      }
    }
  }
`

const StyledMenu = styled(Menu)`
  height: 100%;
  .ant-menu-item-selected {
    background-color: ${props => props.theme.primaryColor} !important;
    color: white !important;
    path {
      fill: white !important;
    }
  }
`

const StyledSpinner = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px;
`

interface StyledRowProps {
  flex?: 'start' | 'end'
}
const StyledRow = styled(Row)<StyledRowProps>`
  &.radio-button-row {
    padding: 8px 0 12px;
  }
  &.data-table-container {
    flex: 1;
    overflow: scroll;
    padding-left: 5px;
  }
  &.carrier-form-row {
    padding: 0;
    display: flex;
    align-items: center;

    .ant-input[disabled] {
      color: unset !important;
      background-color: unset !important;
      border: none !important;
      box-shadow: none;
      cursor: unset !important;
    }
    .new-ticket-form-label {
      text-align: right;
      margin-right: 0.5rem;
    }
    .ant-form-item {
      width: 100%;
      .ant-form-item-control {
        width: 50%;
      }
      .ant-input-number {
        width: 100%;
      }
      .ant-form-item-label {
        text-align: left;
        padding-bottom: unset;
        @media (min-width: ${props => props.theme.size.sm}) {
          min-width: 10rem;
          text-align: right;
        }
      }
      .ant-select-disabled .ant-select-selector {
        color: unset !important;
        background-color: unset !important;
        border: none !important;
        box-shadow: none;
      }
    }
    &.only-read {
      max-height: 2rem;
    }
    textarea {
      resize: none;
    }
  }
  &.new-ticket-form-row {
    padding: 0;
    display: flex;
    align-items: center;
    min-height: fit-content;
    .new-ticket-form-label {
      text-align: right;
      margin-right: 0.5rem;
    }
    .ant-form-item {
      width: 100%;
      .ant-form-item-control {
        width: 50%;
      }
      .ant-input-number {
        width: 100%;
      }
      .ant-form-item-label {
        min-width: 10rem;
        text-align: left;
        padding-bottom: unset;
        @media (min-width: ${props => props.theme.size.sm}) {
          text-align: right;
          padding-bottom: 0.5rem;
        }
      }
    }
    .ant-form-item-explain {
      display: none;
    }
    .ant-form-item {
      margin-bottom: 0.5rem;
    }
    .auxiliar-information-label {
      padding-top: 0.25rem;
      padding-left: 0.6875rem;
    }
  }
  &.invisible {
    visibility: hidden !important;
  }
  &.sticky-bottom,
  &.sticky-options {
    padding: 0.5rem;
    top: 0;
    gap: 0.5rem;
    z-index: 2;
    justify-content: space-between;
    flex-wrap: wrap;
    background-color: white;
    @media (max-width: ${props => props.theme.size.md}) {
      justify-content: ${props => `flex-${props.flex ?? 'end'}`};
    }
  }
  &.border-bottom {
    border-bottom: 1px solid ${props => props.theme.lightGray};
  }
  &.sticky-bottom {
    bottom: 0 !important;
    padding: 0.5rem 0;
    border-top: 1px solid ${props => props.theme.lightGray};
    justify-content: center;
  }
  &.boards-container {
    overflow: auto;
    height: fit-content;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
    overflow: auto;
    height: 100%;
    position: relative;
  }
  &.ticket-handler {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    padding: 0 0.5rem 0.5rem 0.5rem;
    .ant-spin-spinning {
      display: flex;
      flex: 1;
      justify-content: flex-end;
    }
  }
  .from-to-handler-container,
  .week-handler-container {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    .arrow-disabled svg {
      fill: #595959;
    }
  }
  .option-button {
    font-size: 1.5rem;
    align-items: center;
    display: flex;
  }
`
const StyledMenuItem = styled(Menu.Item)`
  & span {
    margin-left: 10px;
  }
`

const StyledCheckbox = styled(Checkbox)`
  display: flex;
  justify-content: center;
  margin-bottom: 0.75rem;
  margin-left: 12rem;
`

const StyledButton = styled(Button)`
  width: 100% !important;
  background-color: ${props => props.theme.primaryColor} !important;
  border: none !important;
  color: white !important;
  &.inline {
    padding: 0.55rem;
    display: flex !important;
    align-items: center !important;
    width: fit-content !important;
  }
  &.clean-tpl {
    padding: 0.55rem;
    display: flex !important;
    align-items: center !important;
    width: fit-content !important;
  }
  &.option {
    background-color: white !important;
    border: 1px solid ${props => props.theme.primaryColor} !important;
    span,
    svg {
      fill: ${props => props.theme.primaryColor} !important;
      color: ${props => props.theme.primaryColor} !important;
    }
  }
  &.add-note {
    margin-left: auto;
    width: fit-content !important;
    display: flex;
  }
  &.disabled {
    background-color: ${props => props.theme.darkGray} !important;
  }
  & p {
    width: 100%;
  }
  & > span > svg {
    fill: white;
  }
`
const StyledSelect = styled(Select)`
  flex: 1;
  width: 100%;
`

const StyledInput = styled(Input)`
  flex: 1;
  width: 100%;
`

const StyledForm = styled(Form)`
  .ant-form-item-control {
    width: 50%;
  }
`
const StyledModal = styled(Modal)`
  .ant-modal-content {
    display: flex;
    flex-direction: column;
  }
  &.create-edit-modal {
    max-width: 64rem;
    min-width: fit-content;
    .ant-modal-body {
      padding-top: 0 !important;
      .ant-tabs-content {
        display: flex;
      }
      .ant-tabs-tabpane {
        flex: 1;
      }
    }
  }
  .ant-modal-body {
    flex: 1;
    display: flex;
    max-height: 65vh;
    overflow: auto;

    .ant-tabs-content-holder {
      display: flex;
      flex: 1;
    }
  }
  .ant-modal-header {
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 0.75rem;
  }
  .ant-tabs-nav::before {
    border-bottom: unset;
  }
  .ant-tabs-tab-btn {
    color: ${props => props.theme.darkGray};
  }
  .ant-tabs-tab-btn {
    color: ${props => props.theme.darkGray};
  }
  .close-icon-white svg {
    color: ${props => props.theme.white};
  }
  &.bulk-data-upload {
    width: 1500px !important;
    #file-upload-button {
      display: none;
    }
    .ant-modal-header h1 {
      color: ${props => props.theme.darkGreenText};
      font-size: 1.25rem;
      margin-bottom: 0;
      margin-top: 0.125rem;
    }
    .ant-modal-title {
      font-size: 1.5rem;
      margin-right: 1.75rem;
    }
  }
  .info-upload-data-modal {
    margin-left: 0.25rem;
  }
  .info-upload-data-modal svg {
    cursor: help;
    color: ${props => props.theme.darkText} !important;
    transform: translateY(0.0625rem);
  }
  .ant-tabs {
    width: 100%;
  }
  &.detail-modal {
    max-width: 64rem;
    min-width: fit-content;
    .ant-modal-header {
      background-color: ${props => props.theme.white};
      .ant-modal-title {
        color: ${props => props.theme.darkText} !important;
      }
    }
    .ant-modal-body {
      padding: 1.25rem 1rem !important;
      .ant-tabs-content-holder {
        display: flex;
        flex: 1;
      }
      .ant-tabs-nav {
        margin: unset;
        margin-bottom: 0.75rem;
        .ant-tabs-tab {
          padding: 0.25rem 0;
        }
      }
      .form-section {
        .form-detail-title {
          padding: 0.75rem 0.5rem;
          font-weight: 700;
          gap: 0.25rem;
        }
        .section-header {
          padding: 0.4rem 0.5rem;
        }
        .ant-btn-link {
          padding: unset;
        }
        .new-ticket-form-row {
          border: none;
          border-bottom: unset;
          min-height: 2rem;
          padding: 0 0.5rem;
          &:last-child {
            border-bottom: none;
          }
        }
        .ant-picker,
        .ant-select-disabled .ant-select-selector,
        .ant-input {
          border: unset;
          padding: unset;
          display: flex;
          align-items: center;
          line-height: 0.5rem;
          justify-content: flex-start;
        }
      }
    }

    .ant-form-item-label {
      font-weight: bold;
      padding-bottom: unset !important;
      > label > div {
        display: none;
      }
    }
    .ant-input-disabled {
      color: ${props => props.theme.lightBlack};
      background-color: transparent !important;
    }
    .ant-form-item-required {
      font-weight: bold;
      ::before {
        display: none !important;
      }
    }
    .ant-select-selector {
      color: black !important;
    }
    .ant-row-center {
      justify-content: unset;
      padding-left: 5px;
      margin-bottom: unset !important;
    }
    .ant-form-item {
      margin-bottom: unset;
    }
  }
  .ticket-form__document-number-id-input {
    background-color: white;
    color: #5f5e5e;
    border: none;
  }
  .ticket-form__date-picker-viewer {
    width: 100%;
    height: 32px !important;
  }
  .ticket-form__date-picker-input {
    border-radius: 0.25rem;
  }
  .ticket-form__time-picker-input {
    border-radius: 0.25rem;
    width: 100%;
  }
  .ticket-form__is-warning {
    border: #ff4d4f 1px solid;
  }
  .ticket-form__assign-radio-group {
    gap: 0.5rem;
  }
  .ticket-form__assign-radio-input {
    align-items: center;
  }
  .ticket-field-value-error {
    color: red;
  }
  .new-ticket-form-amount {
    display: flex;
    justify-content: center;
    padding-left: 8px;
    margin-bottom: 1rem;
  }
  .note-input-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .ticket-form__dates-column {
    gap: 0.25rem;
    margin-bottom: 0.5rem;
  }
  .ticket-form {
    display: flex;
    flex: 1;
    overflow: hidden;
    gap: 2rem;
    max-height: 100%;
    .ticket-form__column {
      flex: 1;
      &.ticket-data {
        gap: 0.75rem;
        max-height: 100%;
        overflow-y: auto;
        padding-right: 1rem;
        min-width: fit-content;
        width: 100%;
        max-width: 30.5rem;
      }
      &.carrier-selection {
        width: fit-content;
        padding-right: 0.125rem;
      }
    }
  }
  .refs-icon-info {
    font-size: 1.5rem;
    cursor: help;
    margin-bottom: 1.75rem;
  }
  .form-comments__non-editable {
    margin-bottom: 0.5rem;
  }
  .form-comments__editable {
    display: flex;
    justify-content: flex-end;
    padding-right: 4px;
  }
  .form-comments__p {
    margin-bottom: 0;
  }
  .ticket-modal-spin-container {
    padding: 2rem;
    flex: 1;
    justify-content: center;
  }
  .ticket-modal-spinner {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
  }
  .ticket-modal-header-tools {
    width: calc(100% - 2rem);
    display: flex;
    justify-content: space-between;
  }
`
const ActionsCellContainer = styled(Row)`
  gap: 0.5rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`
const { RangePicker } = DatePicker
const DateFromTo = styled(RangePicker)`
  width: 100%;
`
const StyledTableRow = styled(Row)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 430px;
`
const StyledCenteredIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledFont = styled.div`
  font-weight: bold;
  color: #939393;
  padding: 10px;
`
const ArrowAsc = styled(CaretUpOutlined)`
  svg {
    fill: ${props => props.theme.darkGray};
    transition: ease all 500ms;
  }
  &.selected svg {
    fill: ${props => props.theme.darkGreenText};
  }
`
const ArrowDesc = styled(CaretDownOutlined)`
  svg {
    fill: ${props => props.theme.darkGray};
    transition: ease all 500ms;
  }
  &.selected svg {
    fill: ${props => props.theme.darkGreenText};
  }
`
const StyledLabels = styled.span`
  padding: 0 8px 0 5px;
`
const StyledStrongText = styled.span`
  font-weight: bold;
`
const StyledUnderlinedText = styled.span`
  text-decoration: underline;
`

const StyledSelectLabel = styled.label`
  border: none;
  background: transparent;
  color: #355891;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
  font-weight: bold;
`

const FlexRow = styled.div`
  display: flex;
`

const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
`

const SquareMonitor = styled(FlexCol).attrs({ as: 'button' })`
  border: 1px solid ${theme.gray};
  border-radius: 0.75rem;
  margin-top: 0.75rem;
  padding: 0.875rem;
  font-size: 0.8rem;
  text-transform: uppercase;
  white-space: nowrap;
  min-width: 10.5rem;
  line-height: 0.875rem;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  background: ${theme.white};
  transition: background 0.2s ease, transform 0.1s ease;

  &:hover {
    background: ${theme.lightGray};
  }

  &:active {
    transform: scale(0.98);
  }
`

export {
  StyledButton,
  StyledRow,
  ContentContainer,
  StyledMenuItem,
  StyledMenu,
  StyledSelect,
  StyledForm,
  StyledModal,
  ActionsCellContainer,
  DateFromTo,
  StyledSpinner,
  StyledFont,
  ArrowAsc,
  ArrowDesc,
  StyledTableRow,
  StyledCenteredIcon,
  StyledLabels,
  StyledSelectLabel,
  StyledStrongText,
  StyledUnderlinedText,
  FlexRow,
  FlexCol,
  StyledInput,
  StyledCheckbox,
  SquareMonitor,
}
